import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ProductConditionListCheckModel} from "../../models/condition-lists/product-condition-list-check.model";
import {ProductMtaModel} from "../../models/mta/product-mta.model";
import {ProductModel} from "../../models/product/product.model";
import {ApiResultDispatcherService} from "../api/api-result-dispatcher.service";
import {ApiService} from "../api/api-service";

@Injectable({
    providedIn: "root"
})
export class ProductService {
    private API_GET_PRODUCT_DETAILS_BY_ID = "/nop/quickshop/getProduct";
    private API_GET_PRODUCT_DETAILS_BY_CATALOGUE_NUMBER = "/nop/quickshop/getProductByCatalogueNumber";
    private API_CHECK_CONDITIONS = "/nop/conditionListProducts/checkConditions";
    private API_CHECK_MTA = "/nop/MtaListProduct/checkMtaMessages";

    public constructor(
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService
    ) { }

    public getProductById(productId: number): Observable<ProductModel> {
        const http = this.apiService.executeGet<ProductModel>(
            this.API_GET_PRODUCT_DETAILS_BY_ID,
            {
                productId: productId
            }
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public getProductByCatalogNumber(catalogueNumber: string): Observable<ProductModel> {
        const http = this.apiService.executeGet<ProductModel>(
            this.API_GET_PRODUCT_DETAILS_BY_CATALOGUE_NUMBER,
            {
                catalogueNumber: catalogueNumber
            }
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public checkConditions(productIds: Array<number>): Observable<Array<ProductConditionListCheckModel>> {
        const http = this.apiService.executeGet<Array<ProductConditionListCheckModel>>(
            this.API_CHECK_CONDITIONS,
            {
                productIds: productIds.join(",")
            }
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public checkMta(productIds: Array<number>): Observable<Array<ProductMtaModel>> {
        const http = this.apiService.executeGet<Array<ProductMtaModel>>(
            this.API_CHECK_MTA,
            {
                productIds: productIds.join(",")
            }
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }
}
